export default __webpack_public_path__ + "static/media/beginner_avatar.e7b4a90f.jpg";